import ActionModal from "components/Settings/components/ActionModal";
import PlanSummaryCard from "../PlanSummaryCard";
import { ModalSuccess } from "assets/icons";
import { retrieveToken } from "utils/storage";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function SuccessModal({ open, setOpen }) {
  const [plan, setPlan] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const savedPlan = retrieveToken("selectedPlan");
    if (savedPlan) {
      setPlan(JSON.parse(savedPlan));
    }
  }, [open]);

  const handleCancel = () => {
    navigate("/plans", { replace: true });
  };

  return (
    <ActionModal
      open={open}
      setOpen={setOpen}
      closable
      width={596}
      className="summary-modal"
      centerMode={false}
      centered
      onCancel={handleCancel}
    >
      <div className="flex flex-col gap-8 w-full">
        <div className="flex flex-col gap-4 items-center success-modal-header">
          <span className="modal-icon">
            <ModalSuccess />
          </span>
          <span className="text-center success-title">
            Welcome to Click4marry family
          </span>
        </div>
        <PlanSummaryCard data={plan} />
      </div>
    </ActionModal>
  );
}

export default SuccessModal;
